// ========== Start Open & Close size guide popup ==========
const sizeGuidePopup = document.querySelector('.size-guide');

// ~~~~~~~~~~ Start Helper functions ~~~~~~~~~~
const openSizeGuideModal = (sizeGuidePopup) => {
  sizeGuidePopup.classList.remove('hidden');
  document.body.style.overflow = "hidden";
}

const closeSizeGuideModal = (sizeGuidePopup) => {
  sizeGuidePopup.classList.add('hidden');
  document.body.style.overflow = "auto";
}
// ~~~~~~~~~~ End Helper functions ~~~~~~~~~~

const sizeGuideFunction = function() {
  const sizeGuidebtns = document.querySelectorAll('.size-guide-btn');
  const sizeGuideClose = document.querySelector('.size-guide__close');

  // Open Size Guide 
  sizeGuidebtns.forEach(btn => {
    btn.addEventListener('click', () => openSizeGuideModal(sizeGuidePopup));
  })

  // Close Size Guide
  sizeGuideClose.addEventListener('click', () => closeSizeGuideModal(sizeGuidePopup));
  sizeGuidePopup.addEventListener('click', function(e) {if (e.target === this) closeSizeGuideModal(sizeGuidePopup)});
  window.addEventListener('keydown', e => {if (e.key === 'Escape') closeSizeGuideModal(sizeGuidePopup)});
}

document.addEventListener('DOMContentLoaded', () => {
  if (sizeGuidePopup) sizeGuideFunction();
  
  // Check if we should auto-open size guide from URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('openSizeGuide') === 'true') {
    // Small delay to ensure size guide is fully initialized
    setTimeout(() => {
      if (sizeGuidePopup) openSizeGuideModal(sizeGuidePopup);
    }, 1000);
  }
});
// ========== End Open & Close size guide popup ==========


// ========== Start Type Swatch functionality ==========
const sizeGuideTypes = document.querySelectorAll('.guide__swatch--type');

sizeGuideTypes.forEach(el => {
  el.addEventListener('click', function() {

    if (el.classList.contains('active')) return;

    const getType = this.getAttribute('data-type');
    const sizeGuideSlider = this.closest('.guide-swatch').querySelector('.guide__swatch--slider');
    const sizeGuide = this.closest('.size-guide');
    const allTdSpan = sizeGuide.querySelectorAll('.guide-table td span');
    
    // 1- Remove Active Class
    sizeGuideTypes.forEach(type => type.classList.remove('active'));

    // 2- Add Active Class
    this.classList.add('active');

    // 3- Update Slider
    if (getType == 'in') {
      sizeGuideSlider.classList.remove('active-cm');
      sizeGuideSlider.classList.add('active-in');
    } else if (getType == 'cm') {
      sizeGuideSlider.classList.remove('active-in');
      sizeGuideSlider.classList.add('active-cm');
    } 

    // 4- Update Type
    allTdSpan.forEach(span => span.classList.toggle('hidden'));
  })
})
// ========== End Type Swatch functionality ==========


// ========== Start Mobile options functionality ==========
const mobileSizeOptions = document.querySelectorAll('.mobile-size-options > div');

const showHideMobileSizeColumns = function() {
  if (window.innerWidth < 750) {
    mobileSizeOptions.forEach(option => {
      if (option.classList.contains('active')) {
        const colOrder = option.getAttribute('data-order');
        const thisTableContainer = option.closest('.js-size-table-container');

        thisTableContainer.querySelectorAll('.guide-table tr th:not(:first-child)').forEach(el => el.classList.add('hidden'));
        thisTableContainer.querySelectorAll('.guide-table tr td:not(:first-child)').forEach(el => el.classList.add('hidden'));
    
        thisTableContainer.querySelectorAll(`.guide-table tr th:nth-child(${colOrder})`).forEach(el => el.classList.remove('hidden'));
        thisTableContainer.querySelectorAll(`.guide-table tr td:nth-child(${colOrder})`).forEach(el => el.classList.remove('hidden'));
      }
    })

  } else {
    document.querySelectorAll('.guide-table tr th:not(:first-child)').forEach(el => el.classList.remove('hidden'));
    document.querySelectorAll('.guide-table tr td:not(:first-child)').forEach(el => el.classList.remove('hidden'));
  }
}

document.addEventListener('DOMContentLoaded', showHideMobileSizeColumns);
window.addEventListener('resize', showHideMobileSizeColumns);


mobileSizeOptions.forEach(option => {
  option.addEventListener('click', function() {
    const thisTableContainer = option.closest('.js-size-table-container');
    
    thisTableContainer.querySelectorAll('.mobile-size-options > div').forEach(el => el.classList.remove('active'));
    this.classList.add('active');
    showHideMobileSizeColumns();
  })
})
// ========== End Mobile options functionality ==========

// ========== Start How To Measure Scoll ==========
const howToMeasureBtn = document.querySelector('.measuring-guide-btn');

howToMeasureBtn.addEventListener('click', function(e) {
  const sizeGuidContainer = document.querySelector('.size-guide__container');
  const howToMeasureSection = document.querySelector('.measuring-guide');

  e.preventDefault();

  // sizeGuidContainer.scrollTo({
  //   top: howToMeasureSection.offsetTop,
  //   behavior: 'smooth'
  // });

  howToMeasureSection.scrollIntoView({ behavior: "smooth"});
})
// ========== End How To Measure Scoll ==========


// ========== Start Navigate and Open Size Guide ==========
document.addEventListener('DOMContentLoaded', () => {
  const navigateAndOpenBtn = document.querySelector('.navigate-and-open-size-guide-btn');
  
  if (navigateAndOpenBtn) {
    navigateAndOpenBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const targetUrl = this.getAttribute('href');
      if (!targetUrl) return;
      
      // Parse the URL and add/update the openSizeGuide parameter
      try {
        const url = new URL(targetUrl, window.location.origin);
        url.searchParams.set('openSizeGuide', 'true');
        
        // Navigate to the URL
        window.location.href = url.toString();
      } catch (error) {
        // Fallback: if URL parsing fails, just append parameter
        const separator = targetUrl.includes('?') ? '&' : '?';
        window.location.href = targetUrl + separator + 'openSizeGuide=true';
      }
    });
  }
});
// ========== End Navigate and Open Size Guide ==========


document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector("#size-guide-fit-review  .okeReviews ")) {
    // make the true to size line thicker
    let fitWidgetSizeBar = document.querySelector("#size-guide-fit-review .oke-w-header-content .oke-barBlocks--centered");
    if(fitWidgetSizeBar){
        let precentageText = document.querySelector("#size-guide-fit-review .oke-w-header-content .oke-attrBar-title .oke-a11yText").innerText;
        if(precentageText.includes("0.0")){
            fitWidgetSizeBar.querySelector(".oke-barBlocks-bg-shading").style.setProperty("min-width", "30px", "important");
            fitWidgetSizeBar.querySelector(".oke-barBlocks-bg-shading").style.setProperty("transform", "translateX(-13px)", "important");
            fitWidgetSizeBar.querySelector(".oke-barBlocks-bg-centerLine").style.setProperty("background", "transparent", "important");
        }
    }

    // show the reviews count
    let fit_reviews_count = document.querySelector("#size-guide-fit-review .fit-count");
    let product_count = document.querySelector("#size-guide-fit-review .oke-w-navBar-item-count").innerText;
    product_count = Number(product_count.replace(/,/g, ''));
    if (product_count == 0) {
      return;
    }
    if (product_count == 1){
      fit_reviews_count.innerText = Number(product_count).toLocaleString() + " Review";
    }else {
      fit_reviews_count.innerText = Number(product_count).toLocaleString() + " Reviews";
    }
    document.querySelector("#size-guide-fit-review").classList.remove("hidden");

    document.querySelector("#size-guide-fit-review .fit-link").addEventListener("click", function(e) {
        sizeGuidePopup.classList.add('hidden');
        document.body.style.overflow = "auto";
    });

  }

});
